import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { CustomGetOpportunityQuery } from "generated/graphql";
import parse from "html-react-parser";
type OpportunityForUpdate = NonNullable<CustomGetOpportunityQuery["getOpportunity"]>;

import OpportunityActivityPanel from "./OpportunityActivityPanel";
import OpportunityDetailsPanel from "./OpportunityDetailsPanel";

type Props = {
  opportunity: OpportunityForUpdate;
};

export default function OpportunityOverview({ opportunity }: Props) {
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={4} sx={{ display: "flex" }}>
          <OpportunityDetailsPanel opportunity={opportunity} />
        </Grid>
        <Grid item xs={12} lg={8}>
          <MDBox display="flex" flexDirection="column" gap={2}>
            <Card>
              <MDBox p={2}>
                <MDTypography variant="h6" fontWeight="medium" mb={1}>
                  Notes
                </MDTypography>
                {opportunity.notes?.trim() ? (
                  <MDTypography
                    variant="button"
                    sx={{
                      "& p": { m: 0 },
                      "& *": { fontSize: "inherit", lineHeight: "inherit" },
                    }}
                  >
                    {parse(opportunity.notes)}
                  </MDTypography>
                ) : (
                  <MDTypography variant="button">—</MDTypography>
                )}
              </MDBox>
            </Card>

            <OpportunityActivityPanel opportunity={opportunity} />
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}
